module.exports = __webpack_public_path__ + "img/ctms_dataSta_img2.4baa34e6.png";